export default {
  cake: { // ALOE TOKEN ADDRESS
    56: '0x3052ee12567bBcb18Ec42E22297076256cEa4c86',
    97: '0xbbB7f6598dD71924B8B80F21A0cACCbb9f114d58',
  },
  masterChef: {
    56: '0xe2C1495206214392525976eFfA1AC49b11aB6Fd8',
    97: '0x9CddCDaBb0f5DA2AD2EE7073184CD336657Cf601',
  },
  wbnb: {
    56: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
    97: '0xae13d989dac2f0debff460ac112a837c89baa7cd',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0x78867BbEeF44f2326bF8DDd1941a4439382EF2A7',
  },
}
